import styled from "styled-components";
import { colors } from "../../../../../../../consts";
import { Paragraph2, TextButton, WrapperContainer } from "../../../../../../../components";
import { PagesWrapper } from "../../../../../../../components/PageSelector/styled";

export const ListWithIconsWrapper = styled(WrapperContainer)`
  padding-bottom: 24px;

  ${PagesWrapper} {
    margin-top: unset;
    border-bottom: unset;
  }
`;

export const FormWrapper = styled(WrapperContainer)`
  padding: 0px 16px 11px;
  margin-top: 16px;
`;

export const RemoveButton = styled(TextButton)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;

  color: ${colors.ERROR};

  svg {
    path {
      fill: ${colors.ERROR};
    }
  }
`;

export const AddLinkButton = styled(TextButton)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  gap: 8px;

  ${Paragraph2} {
    font-weight: 700;
  }
`;
